import { findCheapestTourV2Variation } from 'lib/tours/tourUtils'
import { TourV2ContentSections } from 'constants/tours'
import config from 'constants/config'
import { isEnabledForFeature } from 'lib/config/featureFlagUtils'

function determineTourV2OfferContentSections(
  offer: App.Tours.TourV2Offer,
  region: string,
  selectedVariation?: App.Tours.TourV2OfferVariation,
): Set<TourV2ContentSections> {
  const sections = new Set<TourV2ContentSections>()
  const variation = selectedVariation ?? findCheapestTourV2Variation(offer)

  if (variation?.images.length) {
    sections.add(TourV2ContentSections.GALLERY)
  }

  sections.add(TourV2ContentSections.OVERVIEW)

  if (Object.keys(offer.variations).length > 1) {
    sections.add(TourV2ContentSections.VARIATIONS)
  }

  if (variation?.itinerary?.length) {
    sections.add(TourV2ContentSections.ITINERARY)
  }

  if (
    variation?.travelInclusions.length ||
    variation?.diningInclusions.length
  ) {
    sections.add(TourV2ContentSections.INCLUSIONS)
  }

  if (Object.keys(offer.departures).length && offer.purchasableOptions.length) {
    sections.add(TourV2ContentSections.DEPARTURES)
  }

  if (!offer.isSignatureSeries && config.TAILOR_MADE_TOURS_ENABLED && config.TAILOR_MADE_TOURS_REGIONS && isEnabledForFeature(config.TAILOR_MADE_TOURS_REGIONS, region)) {
    sections.add(TourV2ContentSections.ADDITIONAL_WAYS)
  }

  if (offer.finePrint.sections.length) {
    sections.add(TourV2ContentSections.FINE_PRINT)
  }

  if (offer.faq?.length) {
    sections.add(TourV2ContentSections.FAQ)
  }

  if (offer.rating?.reviewsTotal && offer.rating.score) {
    sections.add(TourV2ContentSections.REVIEWS)
  }

  sections.add(TourV2ContentSections.YOU_MAY_ALSO_LIKE)

  return sections
}

export default determineTourV2OfferContentSections
